<template>
  <div class="paindexouter">
    <div class="page-index">
<!--      <img class="videoone" src="../assets/1920915.png" alt="">-->
      <div class="w100 sta1 flex-cc">
        <div class="flex-cc">
          <img class="mlogo5" src="../assets/logo.png" alt="">
          <div class="mlogo2">
            <div class="mlp1" style="font-size: 27px;">网络空间内生安全知识平台</div>
            <div class="mlp2" style="font-size: 11px;">KNOWLEDGE SYSTEM OF CYBERSPACE ENDOGENOUS SAFETY&SECURITY</div>
          </div>
        </div>
        <div class="sta3">个人中心</div>
      </div>
      <div class="wmiddle">
        <div class="newmiddle">
          <div class="flex-hl mt20">
            <div class="pert flex-cc" @click="changextop(0)" :class="[xtopnum == 0?'xtophot':'']">个人信息</div>
            <div class="pert flex-cc" @click="changextop(1)" :class="[xtopnum == 1?'xtophot':'']">修改密码</div>
            <div class="pert flex-cc" @click="changextop(2)" :class="[xtopnum == 2?'xtophot':'']">我的论坛</div>
            <div class="pert flex-cc" @click="changextop(3)" :class="[xtopnum == 3?'xtophot':'']">
              <span>消息</span>
              <span v-if="noreadinfo.c1 >0 || noreadinfo.c2 >0" class="infored"></span>
            </div>
          </div>
          <!--        个人信息-->
          <div v-show="xtopnum == 0" class="pertmid flex-hl">
            <el-form :model="infoform" :rules="rules" ref="infoform" label-width="100px"
                     class="demo-ruleForm loginform loginformnew">
              <div class="w100 flex-cc">
                <div class="touwai">
                  <div v-if="imageUrl" @click="handleModify" class="xiut">修改</div>
                  <!--                打包改地址-->
                  <el-upload
                      class="avatar-uploader"
                      :http-request="handleAvatarUpload"
                      :show-file-list="false"
                      :on-success="handleAvatarSuccess">
                    <img v-if="imageUrl" :src="imageUrl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </div>
              </div>
              <div class="w100 flex-cc toptl1">{{ userinfo.name }}</div>

              <el-form-item label="用户名" prop="">
                <el-input placeholder="-" v-model="infoform.name"></el-input>
              </el-form-item>
              <el-form-item label="地区" prop="areaId">
                <el-cascader
                    :options="treearea"
                    :props="props"
                    v-model="infoform.areaId"
                    @change="handleChange"
                    clearable></el-cascader>
              </el-form-item>
              <el-form-item label="工作单位" prop="unit">
                <el-select v-model="infoform.unit" placeholder="请选择">
                  <el-option
                      v-for="item in unitlist"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="所属角色" prop="">
                <el-input :disabled="true" placeholder="-" v-model="infoform.role"></el-input>
              </el-form-item>
              <el-form-item label="所属组织" prop="">
                <el-input :disabled="true" placeholder="-" v-model="infoform.dept"></el-input>
              </el-form-item>
              <el-form-item>
                <div @click="subinfoform('infoform')" class="cloginb1">保存</div>
              </el-form-item>
            </el-form>
          </div>
          <!--        修改密码-->
          <div v-show="xtopnum == 1" class="pertmid flex-hl">
            <el-form :model="editform" :rules="rules" ref="editform" label-width="100px"
                     class="demo-ruleForm loginform loginformnew mtb10">
              <el-form-item label="原密码" prop="passwordy">
                <el-input placeholder="请输入" v-model="editform.passwordy" show-password></el-input>
                <!--                  <el-input placeholder="请输入" v-model="editform.passwordy"></el-input>-->
              </el-form-item>
              <el-form-item label="新密码" prop="password">
                <el-input placeholder="请输入" v-model="editform.password" show-password></el-input>
                <!--                  <el-input placeholder="请输入" v-model="editform.password"></el-input>-->
              </el-form-item>
              <el-form-item label="确认新密码" prop="passthr">
                <el-input placeholder="请输入" v-model="editform.passthr" show-password></el-input>
                <!--                  <el-input placeholder="请输入" v-model="editform.passthr"></el-input>-->
              </el-form-item>
              <el-form-item>
                <div @click="subeditform('editform')" class="cloginb1 mt20">保存</div>
              </el-form-item>
            </el-form>
          </div>
          <!--        我的论坛-->
          <div v-if="xtopnum == 2" class="pertmid flex-hl">
            <div class="permidleft">
              <div @click="changelunnum(0)" class="perw1 flex-cc" :class="[lunnum == 0?'perhot':'']">
                <span>我发布的</span>
                <!--              <span class="redm"></span>-->
              </div>
              <div @click="changelunnum(1)" class="perw1 flex-cc" :class="[lunnum == 1?'perhot':'']">
                <span>我回复的</span>
                <!--              <span class="redm"></span>-->
              </div>
            </div>
            <!--          我发布的-->
            <div class="permidright2" v-if="xtopnum == 2 && lunnum == 0">
              <div class="permid22">
                <div class="w100 lunlist1" v-for="(item,idx) in datalist">
                  <div class="w100 cur" @click="todetail(item)">
                    <el-tooltip class="w100 overflow" effect="dark" :content="item.title" placement="top-start">
                      <el-button class="noborder perms9 w100">
                        {{ item.title }}
                      </el-button>
                    </el-tooltip>
                  </div>
                  <div class="w100 flex-hl permb1">
                    <span>{{ item.gmtCreate }}</span>
                    <span class="mlr15">|</span>
                    <span class="flex-cc">
                        <img class="permb2" src="../assets/img/huifu.png" alt="">
                        <span>{{ item.count }}</span>
                  </span>
                    <span class="mlr15">|</span>
<!--                    下单-->
                    <span v-if="item.status == 1 || item.status == 2" class="edit1" @click="todetail(item,'edit')">编辑</span>
                    <span v-if="item.status == 1 || item.status == 2" class="mlr15">|</span>
                    <span v-if="item.status == 1 || item.status == 2" class="del1" @click="deleteinfo(item)">删除</span>
                    <span v-if="item.status == 1 || item.status == 2" class="mlr15">|</span>
                    <span v-if="item.status == 0" class="daishen">待审核</span>
                    <span v-if="item.status == 1" class="yitong">已通过</span>
                    <span v-if="item.status == 2" class="yibo">已驳回</span>
                  </div>
                </div>
              </div>
              <div class="w100 mt20 flex-cc">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :current-page.sync="pageObjlone.currentPage"
                    :page-size="pageObjlone.pageSize"
                    :total="pageObjlone.total"
                    @current-change="pageChangelone">
                </el-pagination>
              </div>
            </div>
            <!--          我回复的-->
            <div class="permidright" v-if="xtopnum == 2 && lunnum == 1">
              <div class="permid21">
                <div class="w100" v-for="(item,idx) in datalisttwo">
                  <div class="w100 flex-hls">
                    <div class="flex-hlc"><span class="huits1">{{ item.user }}</span><span class="huits2">回复</span>
                      <!--                    <span-->
                      <!--                      class="huits1">你</span><span class="red10 mlr10"></span>-->
                    </div>
                    <div class="huits3">{{ item.gmtCreate }}</div>
                  </div>
                  <div class="w100 flex-hl flex-box mt10">
                    <img class="huits4" src="../assets/img/zuoyin.png" alt="">
                    <span class="huits5 huitsnew5">{{ item.content }}</span>
                    <img class="huits6" src="../assets/img/youyin.png" alt="">
                  </div>
                  <div class="perms7" v-if="item.post">
                    <div class="w100 cur" @click="toping(item)">
                      <el-tooltip class="w100 overflow" effect="dark" :content="item.post.title" placement="top-start">
                        <el-button class="noborder perms9 w100">
                          {{ item.post.title }}
                        </el-button>
                      </el-tooltip>
                    </div>
                    <div class="flex-hl permb1">
                      <span>{{ item.post.user }}</span>
                      <span class="mlr15">|</span>
                      <span>{{ item.post.gmtCreate }} </span>
                      <span class="mlr15">|</span>
                      <span class="flex-cc">
                        <img class="permb2" src="../assets/img/huifu.png" alt="">
                        <span>{{ item.post.count }}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w100 mt20 flex-cc">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :current-page.sync="pageObjltwo.currentPage"
                    :page-size="pageObjltwo.pageSize"
                    :total="pageObjltwo.total"
                    @current-change="pageChangeltwo">
                </el-pagination>
              </div>
            </div>
          </div>
          <!--        消息-->
          <div v-if="xtopnum == 3" class="pertmid flex-hl">
            <div class="permidleft">
              <div @click="changenum(0)" class="perw1 flex-cc" :class="[mynum == 0?'perhot':'']">
                <span>邀请我的</span>
                <span v-if="noreadinfo.c1 >0" class="redm"></span>
                <span v-else class="redmtran"></span>
              </div>
              <div @click="changenum(1)" class="perw1 flex-cc" :class="[mynum == 1?'perhot':'']">
                <span>回复我的</span>
                <span v-if="noreadinfo.c2 >0" class="redm"></span>
                <span v-else class="redmtran"></span>
              </div>
            </div>
            <!--          邀请我的-->
            <div class="permidright" v-if="xtopnum == 3 && mynum == 0">
              <el-form :inline="true" :model="xform" class="demo-form-inline sformin sformin2">
                <el-form-item label="" class="w200 wnew200">
                  <el-input v-model="xform.input" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="邀请时间" class="w270 wnew270">
                  <el-date-picker
                      v-model="xform.time"
                      popper-append-to-body
                      type="daterange"
                      :placement.sync="pickerPlacement"
                      range-separator="至"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间">
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <div class="flex-hl">
                    <div @click="subyaow" class="searbtn1"><i class="el-icon-search"></i></div>
                    <div @click="resetyao" class="searbtn2 cur">重置</div>
                  </div>

                </el-form-item>
              </el-form>
              <div class="permid2">
                <div class="w100" v-for="(item,idx) in datayaolist">
                  <div class="flex-hls">
                    <div class="flex-hlc perms3">
                      <span class="perms1">{{ item.shareUser }}</span>
                      <span class="perms2">邀请</span>
                      <span class="perms1">你</span>
                      <span class="perms2">查看</span>
                      <span v-if="item.status === 0" class="perms5"></span>
                    </div>
                    <div class="perms6">{{ item.gmtCreate }}</div>
                  </div>
                  <div class="perms7" v-if="item.article">
                    <div class="w100" @click="toarti(item)">
                      <el-tooltip class="w100 overflow" effect="dark" :content="item.article.title"
                                  placement="top-start">
                        <el-button class="noborder perms9 w100">
                          {{ item.article.title }}
                        </el-button>
                      </el-tooltip>
                    </div>
                    <div class="flex-hl permb1">
                      <span>{{ item.article.user }}</span>
                      <span class="mlr15">|</span>
                      <span>{{ item.gmtCreate }} </span>
                      <span class="mlr15">|</span>
                      <span class="flex-cc">
                        <img class="permb2" src="../assets/img/huifu.png" alt="">
                        <span>{{ item.article.views }}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w100 mt20 flex-cc">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :current-page.sync="pageObj.currentPage"
                    :page-size="pageObj.pageSize"
                    :total="pageObj.total"
                    @current-change="pageChange">
                </el-pagination>
              </div>
            </div>
            <!--          回复我的-->
            <div class="permidright" v-if="xtopnum == 3 && mynum == 1">
              <div class="permid21">
                <div class="w100" v-for="(item,idx) in datahuimylist">
                  <div class="w100 flex-hls">
                    <div class="flex-hlc"><span class="huits1">{{ item.user }}</span><span class="huits2">回复</span>
                      <!--                                        <span class="huits1">你</span>-->
                      <span v-if="item.status === 0" class="red10"></span>
                    </div>
                    <div class="huits3">{{ item.gmtCreate }}</div>
                  </div>
                  <div class="w100 flex-hl flex-box mt10">
                    <img class="huits4" src="../assets/img/zuoyin.png" alt="">
                    <span class="huits5 huitsnew5">{{ item.content }}</span>
                    <img class="huits6" src="../assets/img/youyin.png" alt="">
                  </div>
                  <div class="perms7" v-if="item.post">
                    <div class="w100 cur" @click="toping(item,1)">
                      <el-tooltip class="w100 overflow" effect="dark" :content="item.post.title" placement="top-start">
                        <el-button class="noborder perms9 w100">
                          {{ item.post.title }}
                        </el-button>
                      </el-tooltip>
                    </div>
                    <div class="flex-hl permb1">
                      <span>{{ item.post.user }}</span>
                      <span class="mlr15">|</span>
                      <span>{{ item.post.gmtCreate }} </span>
                      <span class="mlr15">|</span>
                      <span class="flex-cc">
                        <img class="permb2" src="../assets/img/huifu.png" alt="">
                        <span>{{ item.post.count }}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w100 mt20 flex-cc">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :current-page.sync="pageObjh.currentPage"
                    :page-size="pageObjh.pageSize"
                    :total="pageObjh.total"
                    @current-change="pageChangeh">
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
        <div class="bottomd flex-cc mt50">
          <span>Copyright ◎ 2026 紫金山实验室,All Rights Reserved.</span>
          <span class="shus"></span>
          <img src="../assets/guohui.png" class="jinghui" alt="">
          <span>苏CP备14016373号-4</span>
        </div>
      </div>

    </div>




    <el-dialog
        title="找回密码"
        class="tanpass1"
        append-to-body
        :show-close="false"
        :visible.sync="recoverlook"
        width="40%">
      <el-form :model="recoverform" :rules="rules" ref="recoverform" label-width="100px"
               class="demo-ruleForm loginform">
        <el-form-item label="邮箱" prop="email">
          <el-input placeholder="请输入" v-model="recoverform.email"></el-input>
        </el-form-item>
        <el-form-item class="yaninput" label="邮箱验证码" prop="code">
          <el-input placeholder="请输入" v-model="recoverform.code"></el-input>
          <div @click="getcodet" class="cgetm">{{ msgt }}</div>
        </el-form-item>
        <el-form-item label="设置新密码" prop="password">
          <!--              <el-input v-model="recoverform.name" show-password></el-input>-->
          <el-input placeholder="请输入" v-model="recoverform.password"></el-input>
        </el-form-item>
        <el-form-item label="重复新密码" prop="pwd">
          <!--              <el-input v-model="recoverform.name" show-password></el-input>-->
          <el-input placeholder="请输入" v-model="recoverform.pwd"></el-input>
        </el-form-item>
        <el-form-item>
          <div class="w100 flex-cc">
            <div @click="closerecover" class="quxiaohui mr20">取消</div>
            <div @click="submitFormcover('recoverform')" class="querenlan">确定</div>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>


<script>
import $ from 'jquery'

export default {
  data() {
    // 邮箱正则表达式
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    // 密码强度验证函数
    const validatePassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入密码'))
      }

      // 定义字符类型
      const hasLower = /[a-z]/.test(value) // 小写字母
      const hasUpper = /[A-Z]/.test(value) // 大写字母
      const hasNumber = /\d/.test(value)   // 数字
      const hasSpecial = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(value) // 特殊字符

      // 统计字符类型数量
      const typeCount = [hasLower, hasUpper, hasNumber, hasSpecial].filter(Boolean).length

      if (typeCount < 3) {
        return callback(new Error('密码需包含至少三种字符类型（数字、大小写字母、特殊字符）'))
      }

      // 额外长度要求
      if (value.length < 8) {
        return callback(new Error('密码长度至少8位'))
      }
      if (value.length > 20) {
        return callback(new Error('密码长度不能超过20位'))
      }

      callback()
    }
    // 密码强度验证函数
    const valtwo = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入密码'))
      }

      if (this.locolnum == 1) {//忘记密码
        if (value != this.loginform.password) {
          return callback(new Error('两次密码输入不一致'))
        }
      }
      if (this.recoverlook) {//找回密码
        if (value != this.recoverform.password) {
          return callback(new Error('两次密码输入不一致'))
        }
      }
      callback()
    }
    // 密码强度验证函数
    const valthr = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入密码'))
      }

      if (value != this.editform.password) {
        return callback(new Error('两次密码输入不一致'))
      }
      callback()
    }
    return {
      url: '',
      locolnum: 0,//0立即登录
      pickerPlacement: 'bottom-start',
      sform: {
        input: '',
        time: '',
        user: '',
        categoryId: '',
      },
      // 消息
      xform: {
        input: '',
        time: '',
      },
      msg: '获取',
      seconds: 60,
      clock: '',
      isSend: false,
      msgt: '获取',
      secondst: 60,
      clockt: '',
      isSendt: false,
      mynum: 0,//0邀请的1回复我的
      lunnum: 0,//0发布的1回复的
      xtopnum: 0,//顶部切换0个人信息1修改密码2我的论坛3消息，
      titlew: ' 中外专家为构建网络安全免疫系统建言献策 ',
      recoverlook: false,//找回密码
      imageUrl: '',//头像
      userinfo: JSON.parse(localStorage.getItem('muiuserinfo') || '{}')?.userInfo || null,
      datayaolist: [],
      treearea: [],
      props: {
        label: 'name',
        children: 'children',
        value: 'id',
        emitPath: false
      },
      // 登录
      loginform: {
        nickname: 'a1',
        name: '',
        email: '',
        password: '123456qaz+',
        pwd: '',
        code: '',
      },
      // 找回密码
      recoverform: {
        code: '',
        email: '',
        password: '',
        pwd: '',
      },
      // 个人信息
      infoform: {
        name: '',
        role: '',
        unit: '',
        areaId: '',
        dept: '',
      },
      // 修改密码
      editform: {
        passwordy: '',
        password: '',
        passthr: '',
      },
      pageObj: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
      pageObjh: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
      datahuimylist: [],//回复我的
      datalist: [],
      // 我发布的
      pageObjlone: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
      // 我回复的
      datalisttwo: [],
      pageObjltwo: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
      rules: {
        nickname: [
          {required: true, message: '请输入', trigger: ['blur', 'change']}
        ],
        passwordy: [
          {required: true, message: '请输入', trigger: ['blur', 'change']}
        ],
        name: [
          {required: true, message: '请输入', trigger: ['blur', 'change']}
        ],
        pwd: [
          {required: true, message: '请输入', trigger: ['blur', 'change']},
          {validator: valtwo, trigger: ['blur', 'change']}
        ],
        passthr: [
          {required: true, message: '请输入', trigger: ['blur', 'change']},
          {validator: valthr, trigger: ['blur', 'change']}
        ],
        password: [
          {required: true, message: '请输入', trigger: ['blur', 'change']},
          {validator: validatePassword, trigger: ['blur', 'change']}
        ],
        email: [
          {required: true, message: '请输入', trigger: 'blur'},
          {
            pattern: emailPattern,
            message: '请输入正确的邮箱格式',
            trigger: 'blur'
          }
        ],
      },
      rulesrecover: {
        name: [
          {required: true, message: '请输入', trigger: ['blur', 'change']}
        ],
        email: [
          {required: true, message: '请输入邮箱地址', trigger: 'blur'},
          {
            pattern: emailPattern,
            message: '请输入正确的邮箱格式',
            trigger: 'blur'
          }
        ],
      },
      qiunum: '',
      ipAddress: '',
      topprops: {
        label: 'name',
        children: 'children',
        value: 'id',
        // emitPath:false
      },
      neilist: [],
      unitlist: [],
      noreadinfo: '',//未读信息
    }
  },
  props: {
    colorindex: [String, Object, Array, Number],
    pushnum: [String, Object, Array, Number],
  },
  watch: {
    pushnum(newVal) {
      // 本地存储如果有,说明是点击上面的进来的,并且要根据点击的去刷新指定的框
      if (localStorage.getItem('infonum')) {
        let num = Number(localStorage.getItem('infonum'))
        this.xtopnum = num;
        if (num == 2) {//我发布的
          this.getlunlist();
        } else if (num == 3) {
          this.getmsglist()
        }
      }
      const userData = JSON.parse(localStorage.getItem('muiuserinfo') || '{}')
      this.userinfo = userData?.userInfo || null
      if (this.userinfo) {
        this.infoform = {
          name: this.userinfo.name || '',
          role: this.userinfo.role || '',
          dept: this.userinfo.dept || '',
          areaId: this.userinfo.areaId,
          unit: this.userinfo.unit,
        }
        if (this.userinfo.photo) {
          this.imageUrl = this.userinfo.photo
        }
        this.getnoread()
      }
      this.getuserinfo()

    },
    colorindex: function (val) {
      console.log('val', val)
    },
    $route(to, from) {
      // if (this.$route.query.value) {
      //     let value = String(this.$route.query.value)
      //     this.to(value);
      // }
    }
  },

  beforeDestroy() {
  },
  created() {
    this.getData()
    // if (this.$route.query.value) {
    //     this.to(this.$route.query.value)
    // }
  },
  mounted() {
    // 获取ip地址所属区域
    // this.getIpAddress()
    // 本地存储如果有,说明是点击上面的进来的,并且要根据点击的去刷新指定的框
    if (localStorage.getItem('infonum')) {
      let num = Number(localStorage.getItem('infonum'))
      this.xtopnum = num;
      if (num == 2) {//我发布的
        this.getlunlist();
      } else if (num == 3) {
        this.getmsglist()
      }
    }
    const userDataMounted = JSON.parse(localStorage.getItem('muiuserinfo') || '{}')
    this.userinfo = userDataMounted?.userInfo || null
    if (this.userinfo) {
      this.infoform = {
        name: this.userinfo.name || '',
        role: this.userinfo.role || '',
        dept: this.userinfo.dept || '',
        areaId: this.userinfo.areaId,
        unit: this.userinfo.unit,
      }
      if (this.userinfo.photo) {
        this.imageUrl = this.userinfo.photo
      }
    }
    this.getuserinfo();

    // 个人信息未读和已读（登录后才调用）
    let userinfo = JSON.parse(localStorage.getItem('muiuserinfo') || '{}')?.userInfo || null
    if (userinfo) {
      this.getnoread();
    }
    // 点击日期选择器之外关闭选项
    this.getneilist();//获取顶部分类
    this.gettree();//获取省市区
    this.getunit();

    // $('.qiuout').children('.qiuone').hover(function () {
    //   $(this).addClass('qiuhot').siblings('.qiuone').removeClass('qiuhot');
    // });
  },
  // 22
  methods: {
    getunit() {
      let data = {}
      this.$http({
        url: "unit/list",
        method: "POST",
        data: data
      }).then(res => {
        let data=[];
        if(res.data){
          res.data.forEach((item) => {
            data.push({name:item,id:item});
          })
          this.unitlist = data;
        }
      });
    },
    gettree() {
      let data = {}
      this.$http({
        url: "area/tree",
        method: "POST",
        data: data
      }).then(res => {
        // let treearea = JSON.parse(JSON.stringify(res.data));
        this.treearea = res.data;
        // if(treearea){
        //   treearea.forEach((item,index)=>{
        //     if(item.children){
        //       item.disabled = true;
        //     }
        //   })
        //   this.treearea = treearea;
        // }
        console.log('treearea', this.treearea)
      });
    },
    // 未读数量
    getnoread() {
      // 检查是否有用户信息，没有则不调用
      let userinfo = JSON.parse(localStorage.getItem('muiuserinfo') || '{}')?.userInfo || null
      if (!userinfo) {
        return;
      }
      let data = {}
      this.$http({
        url: "msg/count",
        method: "POST",
        data: data
      }).then(res => {
        this.noreadinfo = res.data;
      }).catch(err => {
        // 如果调用失败（如未登录），忽略错误
        console.log('获取未读消息失败', err);
      });
    },
    subyaow() {
      this.pageObj = {
        pageSize: 10,
        currentPage: 1
      }
      this.getmsglist();
    },
    // 重置邀请我的
    resetyao() {
      this.xform = Object.assign(this.xform, this.$options.data().xform)
      this.pageObj = {
        pageSize: 10,
        currentPage: 1
      }
      this.getmsglist();
    },
    // 跳转文章详情
    toarti(val) {
      let data = {
        msgId: val.id
      }
      this.$http({
        url: "msg/read",
        method: "POST",
        data: this.$form(data)
      }).then(res => {
        this.$emit('cgetnoread', '1');
        localStorage.removeItem('colorindex');
        this.$router.push({
          path: '/knowledge',
          query: {
            parentid: val.article.categoryPid,//父级id
            id: val.article.categoryId,//分类id
            artiid: val.article.id,
          }
        })
      });
    },
    // 删除帖子
    deleteinfo(val) {
      this.$confirm('确认删除帖子吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = {
          postId: val.id
        }
        this.$http({
          url: "post/del",
          method: "POST",
          data: this.$form(data)
        }).then(res => {
          this.$message({
            message: '删除成功！',
            type: 'success'
          });
          this.lunnum = 0;
          this.resetpage();
          this.getlunlist();
        });

      }).catch(() => {

      });
    },
    // 跳转帖子详情
    todetail(val, name) {
      localStorage.removeItem('colorindex');
      this.$router.push({
        path: '/forum',
        query: {
          tieid: val.id,
          edit: name ? name : '',
        }
      })
    },
    // 跳转评价
    toping(val, num) {
      if (num == 1) {
        let data = {
          commentId: val.id
        }
        this.$http({
          url: "comment/read",
          method: "POST",
          data: this.$form(data)
        }).then(res => {
          localStorage.removeItem('colorindex');
          this.$emit('cgetnoread', '1');
          this.$router.push({
            path: '/forum',
            query: {
              tieid: val.post.id,
              pingid: val.id,
            }
          })
        });
      } else {
        localStorage.removeItem('colorindex');
        this.$router.push({
          path: '/forum',
          query: {
            tieid: val.post.id,
            pingid: val.id,
          }
        })
      }

    },
    resetpage(val) {
      // this.mynum = 0;
      if (val) {//有值是顶部切换
        this.lunnum = 0;
        this.mynum = 0;
      }
      // this.datalist = [];
      // this.datalisttwo = [];
      this.pageObjltwo = {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
      this.pageObjlone = {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
      this.pageObj = {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
      this.pageObjh = {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
    },
    getneilist() {
      let data = {
        auth:1
      }
      this.$http({
        url: 'category/tree',
        method: 'post',
        data: this.$form(data)
      }).then((res) => {
        let neilist = JSON.parse(JSON.stringify(res.data));
        if (neilist) {
          neilist.forEach((item, index) => {
            if (!item.children) {
              item.disabled = true;
            }
          })
          this.neilist = neilist;
        }
        this.loading = false;
      }).catch(err => {
        this.loading = false;
      })
    },
    handleChange(val) {
      console.log('val', val)
      // const leafNodes = this.$refs.myCascader.getCheckedNodes(true)
      // this.leafNodeValues = leafNodes.map(node => node.value)
      //
      // console.log('所有选中值:', value)
      // console.log('仅叶子节点值:', this.leafNodeValues)
    },
    handleModify() {
      this.imageUrl = '';
      this.$nextTick(() => {
        this.$el.querySelector('.el-upload__input').click();
      });
    },
    // 自定义上传方法，使用axios自动携带token
    handleAvatarUpload(options) {
      const formData = new FormData();
      formData.append('file', options.file);
      return this.$http({
        url: 'file/upload',
        method: 'POST',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        // 调用成功回调
        if (options.onSuccess) {
          options.onSuccess(res, options.file);
        }
        return res;
      }).catch(err => {
        // 调用失败回调
        if (options.onError) {
          options.onError(err);
        }
        throw err;
      });
    },
    handleAvatarSuccess(res, file) {
      // this.imageUrl = URL.createObjectURL(file.raw);
      if (res.code !== 10200) {
        this.$message.error(res.message);
      } else {
        this.imageUrl = res.data;
      }
    },
    // 顶部切换
    changextop(val) {
      this.$nextTick(() => {
        this.$refs.editform.clearValidate();
      })
      localStorage.setItem('infonum', val);//个人信息的切换靠这个显示
      this.xtopnum = val;
      this.getuserinfo();

      this.resetpage(1);
      this.getuserinfo();
      if (val == 2) {//我的论坛
        this.getlunlist();
      } else if (val == 3) {
        this.getmsglist()
      }
    },
    // 我发布的列表
    getlunlist() {
      let data = {};
      data.pageNumber = this.pageObjlone.currentPage;
      data.pageSize = this.pageObjlone.pageSize;
      data.type = 1;
      this.$http({
        url: "post/page",
        method: "POST",
        data: this.$form(data)
      }).then(res => {
        this.pageObjlone.total = res.data.total;
        this.datalist = res.data.records;
      });
    },
    // 消息-邀请我的
    getmsglist() {
      let data = JSON.parse(JSON.stringify(this.xform));
      data.pageNumber = this.pageObj.currentPage;
      data.pageSize = this.pageObj.pageSize;
      data.time = data.time && data.time.length == 2 ? (this.$timeDay(data.time[0], 1) + '~' + this.$timeDay(data.time[1], 1)) : '';
      this.$http({
        url: "msg/page",
        method: "POST",
        data: this.$form(data)
      }).then(res => {
        this.pageObj.total = res.data.total;
        this.datayaolist = res.data.records;
      });
    },
    // 消息-回复我的
    gethuimy() {
      let data = {};
      data.pageNumber = this.pageObjh.currentPage;
      data.pageSize = this.pageObjh.pageSize;
      data.type = 1;
      this.$http({
        url: "comment/page",
        method: "POST",
        data: this.$form(data)
      }).then(res => {
        this.pageObjh.total = res.data.total;
        this.datahuimylist = res.data.records;
      });
    },
    // 我回复的
    getmyhuilist() {
      let data = {};
      data.pageNumber = this.pageObjltwo.currentPage;
      data.pageSize = this.pageObjltwo.pageSize;
      data.type = 0;
      this.$http({
        url: "comment/page",
        method: "POST",
        data: this.$form(data)
      }).then(res => {
        this.pageObjltwo.total = res.data.total;
        this.datalisttwo = res.data.records;
      });
    },
    pageChange(page) {
      this.pageObj.currentPage = page;
      this.getmsglist();
    },
    pageChangeh(page) {
      this.pageObjh.currentPage = page;
      this.gethuimy();
    },
    pageChangelone(page) {
      this.pageObjlone.currentPage = page;
      this.getlunlist();
    },
    pageChangeltwo(page) {
      this.pageObjltwo.currentPage = page;
      this.getmyhuilist();
    },
    changenum(num) {
      this.mynum = num;
      this.resetpage();
      if (this.mynum == 0) {
        this.getmsglist();
      } else {
        this.gethuimy();
      }
    },
    changelunnum(num) {
      this.lunnum = num;
      this.resetpage();
      if (this.lunnum == 0) {
        this.getlunlist();
      } else {
        this.getmyhuilist();
      }
    },
    closerecover() {
      this.recoverlook = false;
    },
    recover() {
      this.recoverlook = true;
    },
    getcode() {
      if (this.isSend) {
        return
      }
      this.isSend = true;//定时开始之前一定要加上  不然会鬼畜 验证码
      // 鬼畜是因为点击的时候又重复出发定时器了  所有要加上this.isSend = true;
      this.clock = setInterval(() => {
        this.seconds--;
        this.msg = '重新获取(' + this.seconds + 's)';
        if (this.seconds === 0) {
          clearInterval(this.clock);
          this.seconds = 60;
          this.isSend = false;
          this.msg = '重新获取';
        }
      }, 1000);
    },
    getcodet() {
      if (this.isSendt) {
        return
      }
      this.isSendt = true;//定时开始之前一定要加上  不然会鬼畜 验证码
      // 鬼畜是因为点击的时候又重复出发定时器了  所有要加上this.isSend = true;
      this.clockt = setInterval(() => {
        this.secondst--;
        this.msgt = '重新获取(' + this.secondst + 's)';
        if (this.secondst === 0) {
          clearInterval(this.clockt);
          this.secondst = 60;
          this.isSendt = false;
          this.msgt = '重新获取';
        }
      }, 1000);
    },
    // 注册
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert('submit!');
          let data = JSON.parse(JSON.stringify(this.loginform));
          this.loading = true;
          let url = "";
          if (this.locolnum == 0) {
            url = "user/login"
            data.pwd = this.$cryptoadd.encryptData(data.password);//加密
          } else {
            url = "user/reg"
          }
          this.$http({
            url: url,
            method: 'post',
            data: this.locolnum == 0 ? this.$form(data) : data
          }).then((res) => {
            this.loading = false;
            // 注册成功后，后端返回的格式需要确认，如果是LoginDTO格式则处理
            if(res.data && res.data.token) {
                localStorage.setItem('muiuserinfo', JSON.stringify({
                    token: res.data.token,
                    userInfo: res.data.userInfo
                }));
            } else {
                // 如果注册接口返回的不是LoginDTO，可能需要调用登录接口
                localStorage.setItem('muiuserinfo', JSON.stringify({userInfo: res.data}));
            }
            this.$emit('changecolor', 0);
            this.$router.push({path: '/'})
          }).catch(err => {
            this.loading = false;
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    subinfoform(formName) {
      let data = {
        photo: this.imageUrl,
        name: this.infoform.name,
        areaId: this.infoform.areaId,
        unit: this.infoform.unit
      }
      this.$http({
        url: "user/edit",
        method: "POST",
        data: data
      }).then(res => {
        this.$message({
          message: '保存成功！',
          type: 'success'
        });
        this.getuserinfo()
      });
      // this.$refs[formName].validate((valid) => {
      //   if (valid) {
      //     // alert('submit!');
      //   } else {
      //     console.log('error submit!!');
      //     return false;
      //   }
      // });
    },
    getuserinfo() {
      let data = {}
      this.$http({
        url: "user/info",
        method: "POST",
        data: data
      }).then(res => {
        this.userinfo = res.data;
        // 更新localStorage，保持token不变，只更新userInfo
        let userDataStr = localStorage.getItem('muiuserinfo');
        if(userDataStr) {
            try {
                let userData = JSON.parse(userDataStr);
                userData.userInfo = res.data;
                localStorage.setItem('muiuserinfo', JSON.stringify(userData));
            } catch(e) {
                localStorage.setItem('muiuserinfo', JSON.stringify({userInfo: res.data}));
            }
        } else {
            localStorage.setItem('muiuserinfo', JSON.stringify({userInfo: res.data}));
        }
      });
    },
    subeditform(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            // oldpwd:this.$cryptoadd.encryptData(this.editform.passwordy),
            // pwd:this.$cryptoadd.encryptData(this.editform.passthr),
            oldpwd: this.editform.passwordy,
            pwd: this.editform.passthr,
          }
          this.$http({
            url: "user/editpwd",
            method: "POST",
            data: this.$form(data)
          }).then(res => {
            this.$message({
              message: '密码修改成功！',
              type: 'success'
            });
            this.editform = Object.assign(this.editform, this.$options.data().editform)
            this.$nextTick(() => {
              this.$refs.editform.clearValidate();
            })
          });

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    submitFormcover(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert('submit!');
          let data = JSON.parse(JSON.stringify(this.recoverform));
          // this.loading = true;
          this.$http({
            url: 'user/findpwd',
            method: 'post',
            data: this.$form(data)
          }).then((res) => {
            this.$message({
              message: '密码找回成功，请重新登录！',
              type: 'success'
            });
            this.recoverlook = false;
            this.loading = false;
          }).catch(err => {
            this.loading = false;
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    changelonum(num) {
      this.locolnum = num;
      this.loginform = Object.assign(this.loginform, this.$options.data().loginform)
      this.$nextTick(() => {
        this.$refs.loginform.clearValidate();
      })


    },
    getIpAddress() { //获取ip, 位置
      let year = new Date().getFullYear();
      fetch(`https://${year}.ip138.com/`).then(x => x.text()).then(h => {
        let domParser = new DOMParser();
        let doc = domParser.parseFromString(h, "text/html");
        let text = doc?.querySelector('p')?.innerText?.trim();
        console.log('text', text)//您的iP地址是：[xxx.xx.xxx.xxx ] 来自：中国上海xx xx
        try {
          let ip = text.substring(text.indexOf("[") + 1, text.indexOf("]")).trim();
          this.ipAddress.ip = ip;
          let other = text.substring(text.indexOf("来自：") + 3).trim();
          let arr = other.split(" ");
          this.ipAddress.location = arr[0];
          this.ipAddress.type = arr[1];
        } catch (e) {
          console.error(e)
        }
      })
    },

    subsear() {
      console.log(this.sform)

      if (!this.userinfo) {
        this.$message({
          message: '请先进行登录再进行操作！',
          type: 'warning',
          duration: 2000
        });
        return false;
      }

      let timein = [];
      if (this.sform.time.length == 2) {
        timein = [this.$timeDay(this.sform.time[0], 1), this.$timeDay(this.sform.time[1], 1),];
      }
      if (!this.sform.categoryId) {
        this.$message({
          message: '文件类型不能为空！',
          type: 'error'
        });
        return false;
      }
      this.$router.push({
        path: 'knowledge',
        query: {
          parentid: this.sform.categoryId[0],//父级id
          id: this.sform.categoryId[1],//分类id
          time: JSON.stringify(timein),
          input: this.sform.input,
          user: this.sform.user,
        }
      })
    },
    resetsear() {
      console.log(this.sform)
    },
    topage(url) {
      return
      this.$router.push({
        path: url
      })
    },
    onSubmit() {

    },
    to(val) {
      // this.color = val
      // this.Show = false
      // this.show = true
      // if (val == 'companyIntro') {
      //     this.companyShow = true;
      //     this.leaderShow = false;
      //     this.CultureShow = false;
      //     this.title = '公司简介'
      // } else if (val == 'leaderMessage') {
      //     this.companyShow = false;
      //     this.leaderShow = true;
      //     this.CultureShow = false;
      //     this.title = '领导寄语'
      // } else if (val == 'corporateCulture') {
      //     this.companyShow = false;
      //     this.leaderShow = false;
      //     this.CultureShow = true;
      //     this.title = '企业文化'
      // } else {
      //     this.title = '荣誉资质'
      //     this.goHonor(val)
      // }
    },
    getData() {
      // this.$http({
      //   url: 'aboutUs/queryAboutUsInfo',
      //   method: 'post'
      // }).then((res) => {
      //   this.aboutall = res.data
      //   this.aboutUs=res.data.aboutUs
      //   this.banner = res.data.banner
      // })
    },
    goHonor(val) {
      this.title = '荣誉资质'
      this.color = val
      this.Show = true
      this.show = false
      this.$http({
        url: 'aboutUs/queryHonors?page=1&limit=10',
        method: "post"
      }).then((res) => {
        this.honorList = res.data
      })
    }
  },
}
</script>
<!--33-->
<style src="@/styles/roatestyle.css" scoped></style>
<style scoped lang="scss">
@media screen and (max-width: 1440px)  {
  /deep/ {
    .wmiddle .sformin .el-form-item__label{
      line-height: 50px !important;
    }
    .wnew200 .el-input__inner {
      width: 90px !important;
      height: 50px !important;
    }

    .wnew270 .el-input__inner {
      height: 50px !important;
      width: 250px !important;
    }
    .wmiddle .wnew270 .el-range-separator{
      line-height: 44px !important;
    }
  }
  .searbtn1{
    width: 50px !important;
    height: 50px !important;
    line-height: 50px !important;
  }
  .searbtn2{
    width: 50px !important;
    height: 50px !important;
    line-height: 50px !important;
  }
  .newmiddle{
    width: 74vw !important;
  }
  .pertmid{
    height: 73vh !important;
  }
  .bottomd{
    display: none !important;
  }
}
</style>
<style scoped lang="scss">
.paindexouter {
  //background-image: url("../assets/1920915.png");
  //background-size: 100% 100%;
  //background-repeat: no-repeat;


  background-image: url("../assets/img/bgc2.png");
  background-size: cover;
  background-position: bottom center; /* 关键：底部对齐 */
  background-repeat: no-repeat;
}
.wmiddle{
  width: 100%;
  margin:auto;
  height:calc(100vh - 160px);//顶部被提出来了 所以这里不能再是100vh了
  overflow-y: auto;
  &::-webkit-scrollbar {display: inline-block !important;}
  box-sizing: border-box;
}
.touwai {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  margin-bottom: 8px;
  position: relative;
  overflow: hidden;

  .xiut {
    cursor: pointer;
    width: 100%;
    height: 33px;
    position: absolute;
    left: 0;
    bottom: 0;
    text-align: center;
    line-height: 33px;
    background: rgba(0, 0, 0, 0.5);
    z-index: 99;
    color: white;
    font-size: 15px;
  }

  .el-upload {
    img {
      width: 88px;
      height: 88px;
      border-radius: 50%;
    }
  }
}

.toptl1 {
  font-size: 24px;
  color: #fff;
  margin-bottom: 20px;
}

.avatar-uploader .el-upload {
  //border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 88px;
  height: 88px;
  border-radius: 50%;
  line-height: 88px !important;
  text-align: center;
  background: #0E3E6C;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.noborder {
  border: none !important;
  padding: 0 !important;
  color: white !important;
  text-decoration: none;
  background-color: transparent !important;
  text-align: left !important;
  font-weight: bold;
}

.noborder:hover {
  background: none;
  color: #0090FF !important;
}

.infored {
  width: 12px;
  height: 12px;
  background: red;
  border-radius: 50%;
  margin-left: 11px;
}

.pert {
  width: 150px;
  height: 50px;
  background: #0E3E6C;
  border: 1px solid #0090FF;
  border-radius: 16px 16px 0 0;
  font-size: 22px;
  margin-right: 10px;
  color: #fff;
  cursor: pointer;
}

.xtophot {
  background: #0090FF;
}

.mlogo5 {
  width: 80px;
  height: 80px;
  margin-right: 30px;
}

.pertmid {
  width: 100%;
  height: 650px;
  background: rgba(14, 62, 108, 0.8);
  border-radius: 0 16px 16px 16px;
  overflow-y: auto;
  &::-webkit-scrollbar {display: inline-block !important;}
  .permidleft {
    width: 20%;
    height: 100%;
    overflow-y: auto;
    &::-webkit-scrollbar {display: inline-block !important;}
    background: rgba(14, 62, 108, 0.9);
    border-radius: 0 16px 16px 16px;
    box-sizing: border-box;
    padding: 20px 0;

    .perhot {
      background: linear-gradient(90deg, #075393 0%, rgba(14, 62, 108, 0.9) 100%);
      position: relative;
      transition: 0.8s;

      &::before {
        content: "";
        width: 6px;
        height: 26px;
        background: #0090FF;
        position: absolute;
        top: 17px;
        left: 0;
      }
    }

    .perw1 {
      width: 100%;
      height: 60px;
      font-size: 18px;
      color: white;
      cursor: pointer;

      .redm {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: red;
        margin-left: 15px;
      }

      .redmtran {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        margin-left: 15px;
      }
    }
  }

  .permidright {
    width: 80%;
    overflow-y: auto;
    &::-webkit-scrollbar {display: inline-block !important;}
    height: 100%;
    box-sizing: border-box;
    padding: 0 40px 20px 40px;
    background: rgba(6, 15, 30, 0.3);
  }

  .permidright2 {
    width: 80%;
    overflow-y: auto;
    &::-webkit-scrollbar {display: inline-block !important;}
    height: 100%;
    box-sizing: border-box;
    background: rgba(6, 15, 30, 0.3);
  }

  .permid2 {
    height: 75%;
    overflow-y: auto;
    &::-webkit-scrollbar {display: inline-block !important;}
  }

  .permid22 {
    height: 88%;
    overflow-y: auto;
    &::-webkit-scrollbar {display: inline-block !important;}
  }

  .lunlist1 {
    box-sizing: border-box;
    padding: 20px 40px;
    border-bottom: 1px solid #0C3761;
  }

  .permid21 {
    height: 90%;
    overflow-y: auto;
    &::-webkit-scrollbar {display: inline-block !important;}
    box-sizing: border-box;
    padding-top: 20px;
  }

  .huits1 {
    font-size: 18px;
    color: white;
  }

  .huits3 {
    font-size: 16px;
    color: #B2B4CB;
  }

  .huits4 {
    width: 21px;
    height: 19px;
    margin-right: 5px;
  }

  .huits6 {
    width: 21px;
    height: 19px;
    margin-left: 5px;
  }

  .huits5 {
    font-size: 16px;
    color: white;
  }

  .huitsnew5 {
    max-width: 90%;
    min-width: max-content;
  }

  .huits2 {
    font-size: 18px;
    color: #A0B8E2;
    margin-left: 10px;
    margin-right: 10px;
  }

  .perms3 {
    font-size: 18px;
  }

  .perms1 {
    color: white;
  }

  .perms2 {
    color: #A0B8E2;
    margin-left: 6px;
    margin-right: 6px;
  }

  .perms5 {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: red;
  }

  .perms9 {
    font-size: 20px !important;
    font-weight: bold;
    color: white;
    margin-bottom: 15px;
    //cursor: none !important;
  }

  .perms9:hover {
    background: none;
    color: white !important;
  }

  .permb1 {
    font-size: 15px;
    color: #B2B4CB;
  }

  .permb2 {
    //width: 15px;
    //height: 13px;
    margin-right: 3px;
  }

  .mlr15 {
    margin-left: 15px;
    margin-right: 15px;
  }

  .mlr10 {
    margin-left: 10px;
    margin-right: 10px;
  }

  .perms6 {
    font-size: 16px;
    color: #B2B4CB;
  }

  .perms7 {
    width: 100%;
    box-sizing: border-box;
    padding: 20px;
    border-radius: 16px;
    background: rgba(14, 62, 108, 0.8);
    margin-top: 15px;
    margin-bottom: 15px;
  }
}

.tanpass1 {
  .el-dialog {
    border-radius: 16px;
  }

  .el-dialog__body {
    padding: 0 0 20px 0;
    background: #0B3E73;
    border-radius: 0 0 15px 15px;
  }

  .el-dialog__header {
    padding: 20px 0 0 0;
    background: #0B3E73;
    border-radius: 15px 15px 0 0;
    text-align: center;

    .el-dialog__title {
      color: white !important;
      font-size: 18px;
      font-weight: bold;
    }
  }

}

.yaninput {
  position: relative;

  .cgetm {
    position: absolute;
    right: 10px;
    top: 18px;
    font-size: 16px;
    line-height: 16px;
    color: #0090FF;
    cursor: pointer;
  }

  .el-input__inner {
    box-sizing: border-box;
    padding-right: 90px;
  }
}

.el-input__inner:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px #060F1E inset !important; /* 背景色 */
  -webkit-text-fill-color: #fff !important; /* 文字颜色 */
}

/* 仅针对密码输入框 */
.el-input__inner[type="password"]:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px #060F1E inset !important;
}

.fogetm {
  width: 100%;
  text-align: center;
  color: white;
  margin-top: 10px;
  font-size: 16px;

  span {
    cursor: pointer;
  }

  span:nth-child(2) {
    text-decoration: underline;
  }
}

.loginformnew {
  width: 45% !important;
  margin-left: 22% !important;
}

.loginformnew .el-input .el-input__inner {
  background: rgba(6, 15, 30, 0.5) !important;
  border: 1px solid #092948 !important;
}

.loginform {
  width: 60%;
  margin-left: 15%;
  box-sizing: border-box;
  padding-top: 30px;

  .cloginb1 {
    cursor: pointer;
    width: 100%;
    height: 50px;
    line-height: 50px;
    background: #0090FF;
    border-radius: 16px;
    text-align: center;
    font-size: 18px;
    color: white;
  }

  ///deep/ {
  .el-form-item__label {
    height: 55px;
    line-height: 55px;
    color: #fff;
    font-size: 16px;
  }

  .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap > .el-form-item__label:before, .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    content: '';
    color: #F56C6C;
  }

  .el-input.is-active .el-input__inner, .el-input__inner:focus {
    border-color: #0090FF !important;
  }

  .el-input__inner::placeholder {
    color: #909399;
  }

  .el-input .el-input__inner {
    background: #060F1E;
    border: 1px solid #060F1E;
    //border-color: #060F1E;
    height: 55px;
    line-height: 55px;
    color: white;
    border-radius: 16px;
  }

  //}
}

.login1 {
  margin: 0 auto;
  width: 860px;
  height: 680px;
  margin-top: 40px;
  box-sizing: border-box;
  padding: 40px 40px 0 40px;
  border-radius: 16px;
  border: 1px solid #1D5FB2;
  background: rgba(6, 15, 30, 0.5);
  box-shadow: 2px 6px 20px 0px rgba(14, 62, 108, 0.2);

  .logind1 {
    cursor: pointer;
    width: 100px;
    text-align: center;
    //background: pink;
    font-size: 24px;
    color: white;
    position: relative;
    //font-weight: bold;
  }

  .logindhot::after {
    content: "";
    width: 20px;
    height: 5px;
    background: #0090FF;
    position: absolute;
    top: 0px;
    right: 0px;
    left: 0px;
    bottom: -57px;
    margin: auto;
  }
}

.qiuno {
  background-image: url(../assets/qiu.png);
  background-repeat: no-repeat;
  cursor: pointer;
}

.qiux {
  background-image: url(../assets/qiuxuan.png);
  background-repeat: no-repeat;
  cursor: pointer;
  color: #0863B1;
}

.cqimg {
  width: 2rem;
  height: 2rem;
}

.cq-t1 {
  font-size: 1.7rem;
  margin-bottom: 1rem;
  font-weight: bold;
}

.cq-t2 {
  font-size: 1rem;
  color: white;
}

.cq-t3 {
  font-size: 1rem;
}

.main-out {
  width: 100vw;
  height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
}


.qiuout {
  //display: none;//放开
  width: 100%;
  height: 500px;
  //background: pink;
  position: relative;

  .qiuone {
    cursor: pointer;
    width: 180px;
    height: 180px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    border-radius: 50%;
    background-image: url("../assets/qiu.png");
    transition: 0.5s;

    .qium1 {
      height: 40px;
    }

    .qium2 {
      font-size: 17px;
      color: white;
    }
  }

  //.qiucold{
  //  background-image: url("../assets/qiu.png");
  //}
  .qiuhot {
    width: 150px !important;
    height: 150px !important;
    background-image: url("../assets/da.png") !important;
    transition: 0.5s;
  }

  .q1 {
    position: absolute;
    top: 220px;
    left: 30px;
  }

  .q2 {
    position: absolute;
    top: 66px;
    left: 170px;
  }

  .q3 {
    position: absolute;
    top: 276px;
    left: 190px;
  }

  .q4 {
    position: absolute;
    top: 146px;
    left: 320px;
  }

  .q5 {
    position: absolute;
    top: 0px;
    left: 420px;
  }

  .q6 {
    position: absolute;
    top: 160px;
    left: 500px;
  }

  .q7 {
    position: absolute;
    top: 320px;
    left: 440px;
  }

  .q8 {
    position: absolute;
    top: 70px;
    left: 660px;
  }

  .q9 {
    position: absolute;
    top: 270px;
    left: 720px;
  }

  .q10 {
    position: absolute;
    top: 90px;
    left: 860px;
  }

  .q11 {
    position: absolute;
    top: 280px;
    left: 940px;
  }
}

.newmiddle {
  width: 1200px;
  margin: 0 auto;
  min-height: 76vh;
}

.wmiddle {
  .w200 .el-input__inner {
    width: 222px;
  }

  .w270 .el-input__inner {
    width: 350px;
  }

  .sformin {
    margin-top: 20px;
  }

  .sformin .el-input__inner {
    height: 60px;
    background: rgba(14, 62, 108, 0.5);
    border-radius: 16px;
    font-size: 18px;
    border: none;
    color: white;
  }

  .sformin2 .el-input__inner {
    height: 60px;
    background: #060F1E;
    border-radius: 16px;
    font-size: 18px;
    border: none;
    color: white;
  }

  .sformin .el-form-item__label {
    height: 60px;
    line-height: 60px;
    color: white;
    font-size: 18px;
  }

  .sformin .el-range-input {
    color: white;
    font-size: 18px;
    background: rgba(14, 62, 108, 0);
  }

  .sformin .el-range-separator {
    line-height: 54px;
    color: white;
  }

  .sinput1 {
    margin-top: 40px;
  }

  .sinput1 .el-input__inner {
    width: 100%;
    height: 60px;
    background: #0E3E6C;
    border: 1px solid #0090FF;
    border-radius: 16px;
    font-size: 18px;
    color: white;
  }

  .searbtn1 {
    width: 60PX;
    height: 60PX;
    text-align: center;
    line-height: 60PX;
    display: inline-block;
    background: #0090FF;
    border-radius: 16px;
    font-size: 24px;
    color: white;
    margin-right: 10px;
  }

  .searbtn2 {
    width: 60PX;
    height: 60PX;
    text-align: center;
    line-height: 60PX;
    display: inline-block;
    background: #DCDFE6;
    border-radius: 16px;
  }

}

.paindexouter {
  overflow: hidden;
  position: absolute;
  width: 100%;
  height:100vh;
  overflow: hidden;
  //overflow-y: scroll;
  top: 0;
  z-index: -1;
}

.page-index {
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  padding-top: 80px;
}

.videoone {
  width: 100%;
  height: 100%;
  //object-fit: cover; /* 保持视频比例并覆盖整个容器 */
}

.videotwo {
  width: 100%;
  //height:500px;
  object-fit: cover; /* 保持视频比例并覆盖整个容器 */
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 9;
}
</style>
